import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import styles from './styles.module.scss';
import {
  Box, Card, CardContent,
  TextField, InputAdornment, SvgIcon, Button,
  Grid
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Loader from '@components/Loader';
import { useNavigate } from 'react-router-dom';
import { getApiReq, postApiReq } from 'src/utils/ApiHandlers';
import { useDispatch } from 'react-redux';
import { showToast } from '@redux/action/index';
import { cutString } from 'src/utils/BasicRequest';
import { imageHandler } from 'src/utils/formatter';

export default function Movies() {
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState('')
  const navigate = useNavigate();
  const [movieList, setMoviesList] = useState([])
  const dispatch = useDispatch();

  const getMovieList = () => {
    setIsLoading(true);
    getApiReq(`/admin/get-movies?search=${search}`)
      .then(res => {
        if (res) {
          setMoviesList(res.data)
          setIsLoading(false);
        }
        else {
          dispatch(showToast({ message: res.error, type: 'error' }))
          setIsLoading(false);
        }
      }).catch(e => { console.log(e) })
  };

  const enableMint = (data, index) => {
    setIsLoading(true);
    let apidata = {
      movieId: data._id,
      agencyId: data.agencyId
    }

    postApiReq(`/admin/mint-movie-asset`, apidata)
      .then((res) => {
        if (res.status) {
          let tempMovie = movieList.slice(0);
          tempMovie[index].isMinted = true;
          setMoviesList(tempMovie);

          dispatch(showToast({ message: 'Enable mint successfully', type: 'success' }))
          setIsLoading(false);
        }
        else {
          dispatch(showToast({ message: res.error, type: 'error' }))
          setIsLoading(false);
        }
      }).catch(e => { console.log(e) })
  };

  useEffect(() => {
    getMovieList();
  }, [search]);

  return (
    <React.Fragment>
      <TableContainer component={Paper} className={styles.tableContainer}>
        <Typography className={styles.heading}>Movies</Typography>
        <p className={styles.paragraph}>A series of games or contests that make up a single unit of competition.</p>
        <Box mt={3}>
          <Card>
            <CardContent>
              <Grid container spacing={3} alignItems='center'>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                          >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    placeholder="Search"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={4} align="right">
                  <Button onClick={() => navigate('/create-movies')} size="large" variant="contained" startIcon={<AddCircleIcon />}>Create Movies</Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
        <Table className='table' sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={styles.tabletitle}>#</TableCell>
              <TableCell className={styles.tabletitle} align="center">Logo</TableCell>
              <TableCell className={styles.tabletitle} align="center">Movies Name</TableCell>
              <TableCell className={styles.tabletitle} align="center">Description</TableCell>
              <TableCell colSpan={3} className={styles.tabletitle} align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {movieList?.map((item, index) => (
              <TableRow
                className={styles.tableRow}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell  >{index + 1}</TableCell>
                <TableCell className={styles.dataView} align="center" ><img className={styles.roundImg} src={imageHandler(item.logo, 1)} alt='' /></TableCell>
                <TableCell className={styles.dataView} align="center" >{item.movieName}</TableCell>
                <TableCell className={styles.dataView} align="center" >{cutString(item.description, 80)}</TableCell>
                {!item.isMinted && <TableCell className={styles.addPlayer} align="center" onClick={() => navigate(`/movie-heroes/${item._id}/${item.movieName}/${item.agencyId}`)}>Add Heros</TableCell>}
                {!item.isMinted && <TableCell className={styles.addPlayer} align="center" disabled={true} onClick={() => enableMint(item, index)}>Enable Mint</TableCell>}
                {item.isMinted && <TableCell className={styles.addPlayer} align="center">Minted</TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {movieList?.length < 1 && <Box align={'center'} w='100%' p={5} >
          <Typography variant="body1" textAlign="center" color="textSecondary">Data not Available</Typography>
        </Box>}
        <Loader isLoading={isLoading} />
      </TableContainer >

    </React.Fragment >
  );
}
